/**
 * Facade for widget-related localStorage keys (origin, wws-*).
 * Single place for key names and format to avoid scattered strings.
 */

export const STORAGE_KEYS = {
	ORIGIN: "origin",
	WWS_BOT_ID: "wws-bot-id",
	WWS_ASSISTANT_ID: "wws-assistant-id",
	WWS_TENANT_ID: "wws-tenant-id",
	WWS_UUID: "wws-uuid",
	WIDGET_TOKEN: "wws-widget-token",
};

export function getOrigin() {
	try {
		const raw = localStorage.getItem(STORAGE_KEYS.ORIGIN);
		return raw ? JSON.parse(raw) : null;
	} catch {
		return null;
	}
}

export function setOrigin({ hostname, pathname }) {
	localStorage.setItem(STORAGE_KEYS.ORIGIN, JSON.stringify({ hostname, pathname }));
}

export function getWwsBotId() {
	return localStorage.getItem(STORAGE_KEYS.WWS_BOT_ID);
}

export function getWwsAssistantId() {
	return localStorage.getItem(STORAGE_KEYS.WWS_ASSISTANT_ID);
}

export function setWwsIds({ assistantId, botId, tenantId, uuid }) {
	if (assistantId != null) localStorage.setItem(STORAGE_KEYS.WWS_ASSISTANT_ID, assistantId);
	if (botId != null) localStorage.setItem(STORAGE_KEYS.WWS_BOT_ID, botId);
	if (tenantId != null) localStorage.setItem(STORAGE_KEYS.WWS_TENANT_ID, tenantId);
	if (uuid != null) localStorage.setItem(STORAGE_KEYS.WWS_UUID, uuid);
}

export function getWidgetToken() {
	try {
		return localStorage.getItem(STORAGE_KEYS.WIDGET_TOKEN) || null;
	} catch {
		return null;
	}
}

export function setWidgetToken(token) {
	if (!token) return;
	try {
		localStorage.setItem(STORAGE_KEYS.WIDGET_TOKEN, token);
	} catch (_) { }
}
